<template>
  <div class="home">
    <h1>Home</h1>
    <h3>Our Mission</h3>
    <p>Tekstur is the solution to a common problem. Most polycarbonate, MDF and acrylic decorative panels have limited durability. They are subject to cracking, chipping, staining and other product degradation. Thus, minimizing their life-span.</p>

    <p>Tekstur is perfect for: Hallways, Lobbies, Elevator Cabs, Feature Walls, Wainscoting, Restaurants, Back-Splash, Stair Treads, Cabinet Facing, Climbing Walls, Exterior Facade, Toilet Partitions, Garden Dividers, Recording Studios, Gym Wall Cladding, Healthcare Facilities, Theatrical Set Design, and much more...</p>

    <p>We created Tekstur panels from materials with extraordinary impact, water, and fire resistance. Many of our panel options also have excellent sound attenuation properties. The materials used are some of the healthiest, most sustainable products in the world.</p>

    <p>By way of our reductive process and design team, we have created a brand that takes these materials beyond their practical applications, and transforms them into utilitarian works of art. Tekstur is both visual and tactile in nature. Not only do the patterned surfaces draw in the eye, but they invite the viewer to touch the material, to engage with the design. </p>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    // HelloWorld
  }
}
</script>
